import type { Distance, Point } from "@pdfking/math"
import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import type { PlotPath as PlotPathAction } from "@pdfking/renderer-api"

import { PlotMixin as mixin } from "../mixins/PlotMixin"

export const PlotPath = CreateRenderFunction({
  computed: {
    // every segment a cubic through its handles; `Z` closes with a line, so a
    // closed path draws its way back to the first point first
    d() {
      const xy = ({ x, y }: Point<Distance>) => `${this.to_px(x)},${this.to_px(y)}`
      const { closed, points } = this.action
      const ring = closed ? [...points, points[0]!] : points
      return [
        `M ${xy(points[0]!)}`,
        ...ring.slice(1).map((to, i) => `C ${xy(ring[i]!.after)} ${xy(to.before)} ${xy(to)}`),
        ...(closed ? ["Z"] : []),
      ].join(" ")
    },
  },
  mixins: [mixin] as const,
  props: {
    action: {} as PlotPathAction,
  },
  render() {
    return (
      <path
        className="pointer-events-none"
        d={this.d}
        // only a closed path fills, as in the pdf and IDML renderers
        fill={this.action.closed ? this.get_color(this.action.fill_color) : "none"}
        stroke={this.get_color(this.action.stroke_color)}
        // its own width, scaling with the page as the print's does
        stroke-width={this.to_px(this.action.stroke_width)}
      />
    )
  },
})
